import { render, staticRenderFns } from "./LegalInfoField.vue?vue&type=template&id=67144ba0&scoped=true&"
import script from "./LegalInfoField.vue?vue&type=script&lang=js&"
export * from "./LegalInfoField.vue?vue&type=script&lang=js&"
import style0 from "./LegalInfoField.vue?vue&type=style&index=0&id=67144ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67144ba0",
  null
  
)

export default component.exports